@let currentLabel = label();
@let currentPlaceholder = placeholder();
@let currentHint = hint();

<div class="mb-2">
  <!-- Label -->
  @if (currentLabel) {
    <label
      [for]="effectiveName()"
      class="block mb-1 text-[12px] font-bold"
      [ngClass]="{ 'text-gray-500': isDisabled() }"
    >
      {{ currentLabel | translate }}
    </label>
  }

  <div class="flex items-center gap-2">
    <div class="relative flex-1" (click)="toggleCalendar()">
      <!-- Input -->
      <input
        type="text"
        [id]="effectiveName()"
        [name]="effectiveName()"
        [value]="formattedValue"
        (focus)="onFocus()"
        (blur)="onBlur()"
        [disabled]="isDisabled()"
        [placeholder]="currentPlaceholder | translate"
        readonly
        class="bg-primary_light block w-full py-2 border-transparent rounded-xl placeholder-gray-400 focus:outline-none text-[16px] transition-colors duration-200 cursor-pointer"
        [ngClass]="{
          'pr-10': true,
          'pl-3': true,
          'border-error': isInvalid() && displayError(),
          'text-error': isInvalid() && displayError(),
          'border-confirm':
            ngControl &&
            ngControl.valid &&
            (ngControl.touched || ngControl.dirty) &&
            displayError(),
          'border-gray-300':
            !isInvalid() &&
            !(ngControl && ngControl.valid && (ngControl.touched || ngControl.dirty)),
          'bg-gray-200 cursor-not-allowed text-gray-500': isDisabled(),
        }"
      />

      <!-- Icono derecho (Calendar) -->
      <span class="absolute text-primary inset-y-0 right-3 flex items-center pointer-events-none">
        <i class="fas fa-calendar-alt"></i>
      </span>
    </div>

    @if (displayError()) {
      <div class="flex items-center">
        <i
          *ngIf="isInvalid() && !isDisabled()"
          class="fas fa-times-circle text-error text-[20px]"
        ></i>
      </div>
    }

    @if (tooltip()) {
      <div class="custom-tooltip-container rounded-full bg-primary_container p-2">
        <i class="fas fa-question text-primary_dark text-[12px] cursor-help"></i>
        <div class="custom-tooltip-text">
          {{ tooltip() | translate }}
        </div>
      </div>
    }
  </div>

  <!-- Hint -->
  @if (currentHint) {
    <p class="mt-1 text-[10px]" [innerHTML]="currentHint | translate"></p>
  }

  <!-- Errores -->
  @if (displayError()) {
    <lib-custom-error-display [errors]="errors()" [control]="ngControl"></lib-custom-error-display>
  }
</div>

<!-- Template para el calendario con CDK Overlay -->
<ng-template #calendarTemplate>
  <div class="bg-white border rounded-lg shadow-lg p-4 w-64">
    <div class="flex justify-between items-center mb-2">
      <button type="button" (click)="previousMonth()" class="p-1 rounded-full hover:bg-gray-100">
        <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M15 19l-7-7 7-7"
          ></path>
        </svg>
        <span class="sr-only">Mes anterior</span>
      </button>
      <div class="font-semibold text-[14px]">{{ monthName | titlecase }} {{ year }}</div>
      <button type="button" (click)="nextMonth()" class="p-1 rounded-full hover:bg-gray-100">
        <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M9 5l7 7-7 7"
          ></path>
        </svg>
        <span class="sr-only">Mes siguiente</span>
      </button>
    </div>
    <div class="grid grid-cols-7 text-center text-[12px] text-gray-500 mb-2">
      @for (day of daysOfWeek; track $index) {
        <div class="font-medium">{{ day }}</div>
      }
    </div>
    <div class="grid grid-cols-7 text-center text-[14px]" (mouseleave)="onGridMouseLeave()">
      @for (day of calendarGrid(); track day.id) {
        <div
          (mouseenter)="onDayHover(day)"
          (click)="selectDate(day)"
          class="flex h-8 w-full items-center justify-center cursor-pointer"
          [ngClass]="{
            'bg-blue-100': day.isSelected && day.isCurrentMonth,
            'bg-blue-50': day.isInPreviewRange && day.isCurrentMonth,
            'rounded-l-full': day.isRangeStart,
            'rounded-r-full': day.isRangeEnd,
          }"
        >
          <button
            type="button"
            class="pointer-events-none mx-auto flex h-8 w-8 items-center justify-center rounded-full"
            [ngClass]="{
              'bg-blue-600 font-semibold text-white':
                day.isRangeStart ||
                day.isRangeEnd ||
                (selectionMode() === 'single' && day.isSelected),
              'text-gray-900':
                (day.isSelected && !day.isRangeStart && !day.isRangeEnd && day.isCurrentMonth) ||
                (!day.isSelected && day.isCurrentMonth && !day.isToday && !day.isInPreviewRange),
              'font-semibold text-blue-600': day.isToday && !day.isSelected,
              'text-gray-400': !day.isCurrentMonth,
            }"
          >
            {{ day.day }}
          </button>
        </div>
      }
    </div>
  </div>
</ng-template>
